/* eslint-disable react/no-unescaped-entities */
import React from 'react';

function LegalCompliance() {
    return (
        <>
            <h1 className="double">Legal Compliance</h1>
            <div>
                <div id="company-legal-protocols" className="anchor" />
                <h2>COMPANY LEGAL PROTOCOLS FOR ACCEPTING WILDLIFE SHIPMENTS</h2>
                <p>
                    Moyle Mink & Tannery does not solicit or accept illegally taken wildlife. The
                    following protocol is designed to ensure the legal operation of our business and
                    protect all out client's furs/hides from seizure by state and federal wildlife
                    agencies.
                </p>
                <p>
                    Protecting our client's inventory is our top priority. The acceptance of any
                    illicit or improperly shipped skins/hides can put everyone's furs/hides at risk.
                    We hope you understand this protocol is in place for your protection, the
                    protection of your client's furs/hides, and for the protection of our company.
                </p>
                <p>
                    If you are using a tannery with no, or lax, receiving protocols you are putting
                    your furs/hides at risk, even if your furs/hides are legal. We apologize for the
                    inconvenience.
                </p>
            </div>
            <div>
                <div id="qualified-clients-only" className="anchor" />
                <h2>QUALIFIED CLIENTS ONLY</h2>
                <p>
                    Moyle Mink & Tannery, Inc. maintains the right to reject any shipment that fails
                    to adhere to the following guidelines:
                </p>
                <ul>
                    <li>
                        With the exception of professional taxidermists and licensed fur
                        buyers/traders; MM&T does not accept hides/skins from individuals who did
                        not personally harvest the animals. If you are not sure if you qualify for
                        client status please contactour office and ask.
                    </li>
                </ul>
                <p>We accept skins/hides from:</p>
                <ul>
                    <li>Licensed Trappers/hunters</li>
                    <li>Licensed Fur buyers/traders</li>
                    <li>Professional Taxidermists</li>
                    <li>Native Americans with tribal I.D.</li>
                    <li>Ranchers of Domestic Animals (such as bison)</li>
                    <li>Government Wildlife Agencies (with supporting documentation)</li>
                </ul>
            </div>
            <hr className="double" />
            <div>
                <div id="lacey-act-compliance" className="anchor" />
                <h2>LACEY ACT COMPLIANCE</h2>
                <p>
                    The following information and statement is found on the back of our order form
                    and the signed statement must accompany all orders or the shipment will be
                    rejected.
                </p>
                <p>
                    The Lacey Act (16USC 3371-3378), is a federal law regulating the shipment of
                    wildlife skins/furs in interstate commerce. In essence, the Lacey Act prohibits
                    the shipment in interstate commerce of wildlife skins/hides that have been taken
                    in violation of the laws of the sate of origin and the receipt and/or possession
                    of any skin/hide so shipped. Moyle Mink & Tannery (MM&T) processes skins
                    received directly from the owners thereof and on a subcontract basis for fur
                    buyers, taxidermists, tanneries, collectors, or other third-party
                    intermediaries, and cannot ascertain in any given instance whether or not a
                    particular fur/skin has been taken in compliance with the laws of the state of
                    origin. Therefore, it is MM&T company policy that the following signed statement
                    shall accompany each shipment from all of our customers. Without a signed
                    statement, the shipment will be rejected. (If more than one order form is used
                    on a large shipment, each order form must be signed.)
                </p>
                <p>
                    I, <span className="underline" />
                    representing <span className="underline" />
                    hereby state that all skins/hides in the accompanying shipment as listed on the
                    order form were received, documented and shipped in accordance with the laws of
                    the state within which I or my company is domiciled. Moreover, to the best of my
                    knowledge, each piece has been handled in accordance with the laws of its
                    origin; including, but not limited to: the taking, tagging, sealing, tag
                    retention, reporting and transportation of each fur/hide.
                </p>
                <p>
                    Signature <span className="underline" />
                    Position <span className="underline" />
                    Date <span className="underline" />
                </p>
                <p>
                    The above protocol is designed to ensure the legal operation of our business and
                    protect our client's furs/hides from seizure by state and federal wildlife
                    agencies. Protecting our client's inventory is our top priority. The acceptance
                    of illicit or improperly shipped skins/hides can put everyone's fur/hides at
                    risk. We hope you understand this protocol is in place for your protection, the
                    protection of your client's furs/hides, and the protection of our company. If
                    you are using a tannery with no, or lax, receiving protocols, you are putting
                    your furs/hides at risk even if your furs/hides are legal. We apologize for the
                    inconvenience.
                </p>
            </div>
            <div>
                <div id="government-tags-and-seals" className="anchor" />
                <h2>DO NOT REMOVE GOVERNMENT TAGS/SEALS</h2>
                <p>
                    Moyle Mink & Tannery will reject furs/hides believed to be missing a required
                    government tag or seal. You, the shipper, must know the laws of your state
                    including which species require tags and/or seals for state export. Skins that
                    have tags/seals attached that have been tampered with or tag/seals that are not
                    attached to the hide will also be rejected.
                </p>
                <ul>
                    <li>
                        Removing tags/seals may put your hides at risk even if it is legal for you
                        to remove them. To be safe do not remove any tag/seal even if you are
                        allowed to do so by the laws of your state.
                    </li>
                    <li>
                        Although your state may allow taxidermists to remove tags/seals, it may
                        still be illegal to ship that raw skin out of your state without a tag/seal.
                        In such cases where laws conflict the export clause takes precedence.
                    </li>
                    <li>
                        Some states may not require a tag for a specific species unless it is going
                        to be shipped out of state raw. It is up to you, the shipper to know these
                        details of wildlife law if you are going to be shipping raw furs/hides out
                        of state.
                    </li>
                    <li>
                        If your state allows a tag to be removed for tanning or “processing” it does
                        not mean it can be removed for shipment to a tannery: it can be removed only
                        at the tannery.
                    </li>
                    <li>
                        Even if your state does not have tags/seals for one or more of the
                        following, we recommend that you request CITES tags from US F&W and attach
                        them to raw otter, bobcat, lynx and wolves for interstate shipment. This is
                        your best insurance against wrongful seizure by law enforcement while your
                        raw skins are in another state or transit.
                    </li>
                </ul>
                <p>
                    Tag Damage: We understand taxidermist's concern that tags attached through the
                    eye of a furbearer or Mt. Lion may damage the eye during processing. Therefore,
                    if attached through the eye, MM&T will remove tags/seals from furbearers and Mt.
                    Lions designated for taxidermy tanning at the time of processing. You will
                    receive the tag back in an envelope with your tanned skin. Tags on pieces
                    designated for Intact Fur Dressing will not be removed and will stay attached to
                    the fur / hide.
                </p>
            </div>
        </>
    );
}

export default LegalCompliance;
